import { createRoute } from "../../utils";

import { changePasswordRoutesObj, changePasswordBreadcrumbs } from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const changePasswordRouteMetadata: IRouteMetadataObj<
  typeof changePasswordRoutesObj
> = {
  home: {
    title: "changePassword",
    lazy: () => import("@/pages/commonPages/changePassword/page"),
    mode: "edit",
    permission: "all",
  },
};

export const changePasswordRoutes = createRoute<typeof changePasswordRoutesObj>(
  changePasswordRoutesObj,
  changePasswordRouteMetadata,
  changePasswordBreadcrumbs,
);
